
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
// import { PARAMETERS } from '@angular/core/src/util/decorators';
import { Observable } from 'rxjs';
// import { of } from 'rxjs/observable/of';
// import { reject } from 'q';
// import { LocalStorage } from '../shared/localstorage.service';
import { GCRole } from './gcrole.model';
import { Agent } from '../shared/agent.model';

@Injectable()
export class AgentService {
    constructor(private http: HttpClient) { }
    gcRoles = new Array<GCRole>();
    getGCRoles(token: string, state: string) {
        return new Promise<GCRole[]>(resolve => {
            this.http.get<GCRole[]>('/api/agentmanagement/gcroles', {
                params: {
                    gcToken: token,
                    state: state
                }
            })
                .subscribe(data => {
                    this.gcRoles = data;
                    resolve(this.gcRoles);
                });
            setTimeout(() => resolve(this.gcRoles), 100000);
        });
    }

    UpdateAgents(UpdateAgents, newRole, token, state) {
        return new Promise<Array<string>>(resolve => {
            this.http.get('/api/agentmanagement/updateagents', {
                params: {
                    gcToken: token,
                    UpdateAgents: UpdateAgents,
                    newRole: newRole,
                    state: state
                }
            }).pipe(
                map(res => res as Array<string>))
                .subscribe(data => {
                    resolve(data);
                });
            setTimeout(() => resolve(), 100000);
        });
    }

    GetAgents(token, userName, rangeStart, rangeEnd, role, property, state) {
        return new Promise<Agent[]>(resolve => {
            this.http.get<Agent[]>('/api/agentmanagement/agents', {
                params: {
                    gcToken: token,
                    UserName: userName,
                    RangeStart: rangeStart,
                    RangeEnd: rangeEnd,
                    Role: role,
                    Property: property,
                    state: state
                }
            }).pipe(
                map(res => res as Agent[] || []))
                .subscribe(data => {
                    resolve(data);
                });
            setTimeout(() => resolve(new Array<Agent>()), 100000);
        });
    }
}
